module.exports = __webpack_public_path__ + "img/teletherapy.9e698706.png";